import { RadialBarChart, RadialBar, Legend } from "recharts";
import "./EngineDashboard.css";
import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import RadialGauge from "./RadialChart";
import CustomGauge from "./RadialChart";
import IndicatorsModal from "./IndicatorsModal";
import GaugesModal from "./GaugeModal";
import MachineModal from "./MachineModal";
import axios from "axios";
import DownAlarm2Modal from "./DownAlarm2";
import DownAlarm1Modal from "./DownAlarm1";
import DownAlarm3Modal from "./DownAlarm3";
import DownAlarm4Modal from "./DownAlarm4";
import ExhaustSection from "./Exhaust";
const gauges = [ 
  
  { name: "Power", value: 959, unit: "kW", max: 2000 },
  { name: "Amperage", value: 1388, unit: "A", max: 2000 },
  { name: "Voltage", value: 454, unit: "V", max: 1000 },
  { name: "Frequency", value: 59.9, unit: "Hz", max: 100 }
];

  
const EquipmentList = () => {
  const [editMode, setEditMode] = useState(false);
  const [indicatorsModal, setIndicatorsModal] = useState(false);
const [gaugesModal, setGaugesModal] = useState(false);
const [downAlarm1Modal, setDownAlarm1Modal] = useState(false);
const [downAlarm2Modal, setDownAlarm2Modal] = useState(false);
const [downAlarm3Modal, setDownAlarm3Modal] = useState(false);
const [downAlarm4Modal, setDownAlarm4Modal] = useState(false);
const [exhaust1Modal,setExhaust1Modal] = useState(false);
const [currentType, setCurrentType] = useState(null);
const openModal = (type) => setCurrentType(type);
const closeModal = () => setCurrentType(null);
const role = localStorage.getItem("role");

const [indicatorsData, setIndicatorsData] = useState([]);
const [gaugesData, setGaugesData] = useState([]);
const [downAlarm2Data, setDownAlarm2Data] = useState([]);
const [downAlarm3Data, setDownAlarm3Data] = useState([]);
const [downAlarm4Data, setDownAlarm4Data] = useState([]);
const [downAlarm1Data, setDownAlarm1Data] = useState([]);
const [alarms1, setAlarms1] = useState([]);
const [alarms2, setAlarms2] = useState([]);
const [alarms3, setAlarms3] = useState([]);
const [alarms4, setAlarms4] = useState([]);
const [alarms5, setAlarms5] = useState([]);
const [alarms6, setAlarms6] = useState([]);
const [alarms7, setAlarms7] = useState([]);
const [alarms8, setAlarms8] = useState([]);
const [alarms9, setAlarms9] = useState([]);
const [alarms10, setAlarms10] = useState([]);
const [alarms11, setAlarms11] = useState([]);
const [alarms12, setAlarms12] = useState([]);
const [alarms13, setAlarms13] = useState([]);
const [alarms14, setAlarms14] = useState([]);
const [alarms15, setAlarms15] = useState([]);
const [alarms16, setAlarms16] = useState([]);
const [alarms17, setAlarms17] = useState([]);
const [alarms18, setAlarms18] = useState([]);
const [alarms19, setAlarms19] = useState([]);

const [exhaustAlarm1Data,setExhaustAlarm1Data]= useState([]);
  const [modal_list, setmodal_list] = useState(false);
  const [editedMachine, setEditedMachine] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [machineData, setMachineData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 const [isLoading, setIsLoading] = useState(false);

  //const authToken = JSON.parse(localStorage.getItem("authUser")).token;
    const authToken =localStorage.getItem("access");
  function tog_list() {
    setmodal_list(!modal_list);
    setEditedMachine(null);
  }

const [formData, setFormData] = useState({
  parameters: [
    { name: "", tag: "", type: "bool", unit: "", value: "", status: false }
  ]
});
  const fetchAlarm = async () => {
    try {
       setIsLoading(true)
      const response1 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=1");
      console.log("resrrr",response1);
const response2 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=2");
const response3 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=3");
const response4 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=4");
const response5 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=5");
const response6 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=6");
const response7 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=7");
const response8 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=8");
console.log("reee8",response8);
const response9 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=9");
const response10 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=10");
const response11 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=11");
const response12 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=12");
const response13 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=13");
const response14 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=14");
const response15 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=15");
const response16 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=16");
const response17 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=17");
const response18 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=18");
const response19 = await axios.get("https://api.hanoch.in/equipment/alarms/?type=19");

 setAlarms1(response1);
  setAlarms2(response2);
      setAlarms3(response3);
      setAlarms4(response4);
  setAlarms5(response5);
      setAlarms6(response6);
       setAlarms7(response7);
       setAlarms8(response8);
  setAlarms9(response9);
      setAlarms10(response10);
      setAlarms11(response11);
  setAlarms12(response12);
      setAlarms13(response13);
       setAlarms14(response14);
       setAlarms15(response15);
  setAlarms16(response16);
      setAlarms17(response17);
      setAlarms18(response18);
  setAlarms19(response19);
     
      } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      }
       else {
        console.error("Error fetching data:", error);
      }
    } finally {
       setIsLoading(false);
    }
  };
    useEffect(() => {
    fetchAlarm();
  }, []);
const handleParamChange = (index, field, value) => {
  const updated = [...formData.parameters];
  updated[index][field] = value;
  setFormData({ ...formData, parameters: updated });
};


const handleAddRow = () => {
  setFormData({
    ...formData,
    parameters: [
      ...formData.parameters,
      { name: "", tag: "", type: "bool", unit: "", value: "", status: false }
    ]
  });
};

const handleDeleteRow = (index) => {
  const updated = formData.parameters.filter((_, i) => i !== index);
  setFormData({ ...formData, parameters: updated });
};


  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

   const filteredMachine = machineData.filter((machine) =>
  
     machine.name.toLowerCase().includes(searchTerm.toLowerCase())
   );

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredMachine.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredMachine.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    
    <React.Fragment>
    <div className="page-content">
        <Container fluid className="">
              <Card className="container-fluid">
     <CardHeader className="custom-card-header">
    <Row>
      <div className="col-lg-4 header-left">
        {/* Time Panel */}
        <div className=" ">
          <div className="time-box">
          <div>UTC:03:36:16</div>
            <div>LOCAL:05:34:16</div>
          </div>
         
        </div>

        {/* Ship Info */}
        <div className="ship-info d-flex align-items-center">
          
          <div>
            <h6 className="ship-title mb-0">ARK Prestige</h6>
            <p className="ship-sub mb-0">IMO 9665671</p>
          </div>
          
        </div>
      </div>
      <div className="col-lg-8 header-right ">
        <div className="menu d-flex justify-content-between me-3">
           <button className="menu-btn mx-2">
              Dashboard
            </button>
             <button className="menu-btn">
            AMS
            </button>
             <button  className="menu-btn">
          Alerts
            </button>
             <button className="menu-btn">
             <Link to="/alarms">Alarms</Link>
            </button>
             <button  className="menu-btn ">
             Voyage
            </button>
             <button className="menu-btn">
             CCTV
            </button>
              <button className="menu-btn">
         Status
            </button>
              <button className="menu-btn">
          Master
            </button>
              <button className="menu-btn">
          User
            </button>
           <div className="counter red11">10</div>
          <div className="counter yellow1">19</div>
           {/* <Button
        className="btn btn-warning mb-3"
        onClick={() => setEditMode(!editMode)}
      >
        {editMode ? "E" : "N"}
      </Button> */}
            {/* <Button color="success" className="add-btn" onClick={() => tog_list()} id="create-btn" > 
              <i className="ri-add-line align-bottom me-1"></i>
               </Button> */}
              {role === "user" && (
  <label className="switch">
    <input
      type="checkbox"
      checked={editMode}
      onChange={() => setEditMode(!editMode)}
    />
    <span className="slider"></span>
  </label>
)}

        </div>
            </div>
      
      </Row>
    </CardHeader>

               

              <CardBody>
  <Row>
    {/* Left Column (Indicators) */}
    <Col lg={3}>
      <div className="indicators">
        <Row className="mb-2">
          <Col xs={6}>
            <div className="border p-2 bg-secondary text-white">G/E COMMON</div>
          </Col>
          <Col xs={6}>
            <div className="border p-2 bg-secondary text-white">GENERATORS</div>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col><Button>1</Button></Col>
          <Col><Button>2</Button></Col>
          <Col><Button>3</Button></Col>
          <Col><Button>4</Button></Col>
        </Row>
         {editMode && (
 <button color="success" 
  className="btn btn-primary"
 size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
 onClick={() => tog_list()}
  id="create-btn" >
     <i className="ri-add-line align-bottom me-0">
      </i> </button>
         )}
         {isLoading ? (
  <div className="text-center mt-3">
    <div className="spinner-border text-primary" role="status"></div>
    <p className="mt-2">Loading alarms...</p>
  </div>
) : (
 alarms1.map((item, i) => (
          <div key={i} className="indicator-row">
            <span>{item.description}</span>
           
             <span className={`status-light ${item.response_color_one?.toLowerCase() || "grey"}`} />
             
           
          </div>
        ))
        )}
      </div>
    </Col>

    {/* Middle Column (Indicator Values) */}
  <Col lg={3}>
  <div className="indicators">
 {editMode && (
        <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setIndicatorsModal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>
 )}
 <div className="panel-container">
   {alarms2.map((item, i) => (
  <div key={i} className="indicator-row">
    <span className="indicator-label">{item.description}</span>
    <div className="indicator-value-group">
      <span className="indicator-value">{item.value}</span>
      <span className="indicator-unit">{item.unit}</span>
    </div>
  </div>
))}
    </div>
  </div>
</Col>


    {/* Right Column (Gauges + Exhaust + Engine) */}
    <Col lg={6}>
      <div className="gauges-engine-container">
        {/* Gauges Row */}
        <Row className="mb-3">
          {gauges.map((g, i) => (
            <Col lg={3} md={6} sm={6} xs={12} key={i}>
              <CustomGauge
                value={g.value}
                max={g.max}
                label={g.value}
                unit={g.unit}
                className="fs-500"
              />
              <div className="text-center gname p-2">{g.name}</div>
            </Col>
          ))}
        </Row>

        {/* Exhaust Section */}
        <Row>
          
          <Col lg={4}>
            <div className="exhaust-left">
               {editMode && (
                <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setGaugesModal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>
               )}
 {alarms3.map((item, i) => (
         <div key={i} className="indicator-row">
                <span>{item.description}</span>
                <span className="value-box">412</span>
                <span>°C</span>
              </div>
    ))}
             
             
            </div>
          </Col>
          {/* <ExhaustSection/> */}
         <Col lg={8}>
  <div className="exhaust-right">
    <div className="title">EXH. GAS TEMP [°C]</div>
    <div className="title">EXH. GAS DEVIATION</div>

    <div className="exhaust-grid">
      {/* Header Row */}
      <div className="header-box">NO 1</div>
      <div className="header-box">NO 2</div>
      <div className="header-box">NO 3</div>
      <div className="header-box">NO 4</div>
      <div className="header-box">NO 5</div>
      <div className="header-box">NO 6</div>

      {/* Temperature Row */}
      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(8)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms8.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(9)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms9.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

             <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(10)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms10.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

           <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(11)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms11.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

               <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(12)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms12.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

  <div className="value-box">
          {editMode? (
                <span
                  className="edit-dot"
                    onClick={() => openModal(13)}
                >
                   <i className="ri-add-line align-bottom me-0"></i>
                </span>
              ) : (
                  alarms13.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
            </div>
      {/* Deviation Row */}
      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(14)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms14.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(15)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms15.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

       <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(16)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms16.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(17)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms17.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(18)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms18.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

      <div className="value-box">
  {editMode ? (
    // Show edit icons
    <span className="edit-dot" onClick={() => openModal(19)}>
      <i className="ri-add-line align-bottom me-0"></i>
    </span>
  ) : (
    // Show mapped alarm values
    alarms19.map((item, i) => (
      <div key={i}>{item.min_value || 405}</div>
    ))
  )}
</div>

    </div>
  </div>
</Col>

        </Row>

        {/* Engine Image */}
        <Row className="mt-3">
          <Col>
            <div className="engine-section">
              <img
                src="/asset/eimm.png"
                alt="Engine"
                className="engine-img container-fluid"
              />
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  </Row>

  {/* Bottom Row (Indicators) */}
  <Row className="mt-3">
   
      <Col lg={3}>
        <div className="indicators">
            {editMode && (
                <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setDownAlarm1Modal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>
               )}
          {alarms4.map((item, i) => (
            <div key={i} className="indicator-row">
              <span>{item.description}</span>
              <span className="status-light green"></span>
            </div>
          ))}
        </div>
      </Col>
       <Col lg={3}>
        <div className="indicators">
            {editMode && (
                <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setDownAlarm2Modal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>
               )}
          {alarms5.map((item, i) => (
            <div key={i} className="indicator-row">
              <span>{item.description}</span>
              <span className="status-light green"></span>
            </div>
          ))}
        </div>
      </Col>
       <Col lg={3}>
        <div className="indicators">
            {editMode && (
                <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setDownAlarm3Modal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>
               )}
          {alarms6.map((item, i) => (
            <div key={i} className="indicator-row">
              <span>{item.description}</span>
              <span className="status-light green"></span>
            </div>
          ))}
        </div>
      </Col>
       <Col lg={3}>
        <div className="indicators">
            {editMode && (
                <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setDownAlarm4Modal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>
               )}
          {alarms7.map((item, i) => (
            <div key={i} className="indicator-row">
              <span>{item.description}</span>
              <span className="status-light green"></span>
            </div>
          ))}
        </div>
      </Col>
    
  </Row>
</CardBody>

              </Card>
          
        
        </Container>
    
      <MachineModal
        isOpen={modal_list}
        toggle={() => setmodal_list(false)}
        editedMachine={editedMachine}
        responseMessage={responseMessage}
        formData={formData}
        handleParamChange={handleParamChange}
        handleDeleteRow={handleDeleteRow}
        handleAddRow={handleAddRow}
        // handleSubmit={handleSubmit}
      />
       {/* Modals */}
    <IndicatorsModal
      isOpen={indicatorsModal}
      toggle={() => setIndicatorsModal(false)}
      initialData={indicatorsData}
      onSave={setIndicatorsData}
    />
     <GaugesModal
      isOpen={gaugesModal}
      toggle={() => setGaugesModal(false)}
      initialData={gaugesData}
      onSave={setGaugesData}
    />
     <DownAlarm1Modal
      isOpen={downAlarm1Modal}
      toggle={() => setDownAlarm1Modal(false)}
      initialData={downAlarm1Data}
      onSave={setDownAlarm1Data}
    />
     <DownAlarm2Modal
      isOpen={downAlarm2Modal}
      toggle={() => setDownAlarm2Modal(false)}
      initialData={downAlarm2Data}
      onSave={setDownAlarm2Data}
    />
     <DownAlarm3Modal
      isOpen={downAlarm3Modal}
      toggle={() => setDownAlarm3Modal(false)}
      initialData={downAlarm3Data}
      onSave={setDownAlarm3Data}
    />
     <DownAlarm4Modal
      isOpen={downAlarm4Modal}
      toggle={() => setDownAlarm4Modal(false)}
      initialData={downAlarm4Data}
      onSave={setDownAlarm4Data}
    />
 {/* <ExhaustSection
      isOpen={exhaust1Modal}
      toggle={() => setExhaust1Modal(false)}
      initialData={downAlarm4Data}
      onSave={setDownAlarm4Data}
    /> */}
{currentType && (
  <ExhaustSection
    isOpen={true}
    toggle={closeModal}
    type={currentType}
  />
)}
    </div>
   </React.Fragment>
  );
};

export default EquipmentList;
